import { render } from "./items-to-post.vue?vue&type=template&id=2b2594e8&scoped=true"
import script from "./items-to-post.vue?vue&type=script&lang=js"
export * from "./items-to-post.vue?vue&type=script&lang=js"

import "./items-to-post.vue?vue&type=style&index=0&id=2b2594e8&scoped=true&lang=css"

import exportComponent from "/Users/aashit.kothari/Documents/jumper-ionic-vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b2594e8"]])

export default __exports__